(function () {
  'use strict';

  /* Nur ein Bootstrapper pro Seite, auch falls das Skript erneut ausgefuehrt
     wird (Section-Re-Render im Theme-Editor). */
  if (window.__pawHeroBoot) return;
  window.__pawHeroBoot = true;

  /* Eine Hero-Instanz. Gibt nichts zurueck; die Aufraeum-Funktion haengt als
     hero.__pawHeroDestroy am Element (Doppel-Init-Schutz + Editor-Unload). */
  function initHero(hero) {
    if (!hero || hero.__pawHeroDestroy) return;

    var viewport = hero.querySelector('[data-hero-viewport]');
    var slides   = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    if (!slides.length) return;

    /* Alle Listener (Elemente, document, window, MQL) laufen ueber on()/onMql()
       und werden beim Entladen der Section wieder entfernt. */
    var cleanups  = [];
    var destroyed = false;
    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }
    function onMql(mql, fn) {
      if (mql.addEventListener) {
        mql.addEventListener('change', fn);
        cleanups.push(function () { mql.removeEventListener('change', fn); });
      } else if (mql.addListener) {
        mql.addListener(fn);
        cleanups.push(function () { mql.removeListener(fn); });
      }
    }

    var dots    = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    var belowBars = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-below]'));
    var prevBtn = hero.querySelector('[data-hero-prev]');
    var nextBtn = hero.querySelector('[data-hero-next]');

    var mqlDesktop = window.matchMedia('(min-width: 768px)');
    var reduceMql  = window.matchMedia('(prefers-reduced-motion: reduce)');

    var count    = slides.length;
    var current  = 0;
    var interval = parseInt(hero.dataset.interval, 10) || 6000;
    var timer    = null;

    /* Video-Gate: automatische Video-Starts (Startslide, Autoplay-Wechsel,
       Viewport-Wechsel) erst nach window 'load' + Reserve UND nur bei
       sichtbarem Hero. Sonst konkurrieren 6-8 MB Video mit dem LCP (Poster).
       Aktive Nutzer-Wechsel (Pfeil/Punkt/Swipe/Editor) starten sofort. */
    var mediaReady  = false;
    var heroVisible = !('IntersectionObserver' in window);

    /* Offene Newsletter-Formulare blockieren Autoplay ZENTRAL: alle
       startAutoplay()-Pfade (mouseleave, focusout, visibilitychange, ...)
       laufen durch wantsAutoplay() — kein Pfad kann die Slide wegdrehen,
       solange jemand tippt. */
    var nlRegistry = [];
    function nlOpenCount() {
      var n = 0;
      for (var i = 0; i < nlRegistry.length; i++) { if (nlRegistry[i].open) n++; }
      return n;
    }

    function wantsAutoplay() {
      return hero.dataset.autoplay === 'true' && count > 1 && !reduceMql.matches && nlOpenCount() === 0;
    }

    function activeVideo(slide) {
      var sel = mqlDesktop.matches ? '.hero__media--desktop' : '.hero__media--mobile';
      var v = slide.querySelector('video' + sel);
      return (v && v.querySelector('source')) ? v : null;
    }

    function loadSlideMedia(slide) {
      if (!slide || slide.dataset.heroLoaded === '1') return;
      slide.dataset.heroLoaded = '1';
      var sources = slide.querySelectorAll('source[data-hero-srcset]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].setAttribute('srcset', sources[i].getAttribute('data-hero-srcset'));
        sources[i].removeAttribute('data-hero-srcset');
      }
      var imgs = slide.querySelectorAll('img[data-hero-src]');
      for (var j = 0; j < imgs.length; j++) {
        var im = imgs[j];
        var ss = im.getAttribute('data-hero-srcset');
        if (ss) { im.setAttribute('srcset', ss); im.removeAttribute('data-hero-srcset'); }
        im.setAttribute('src', im.getAttribute('data-hero-src'));
        im.removeAttribute('data-hero-src');
      }
    }

    /* Reduced motion oder Datensparmodus: gar kein Video-Download, das
       Poster bleibt stehen (saveData gibt es nur mit Network Information API,
       iOS Safari kennt sie nicht). */
    function videoBlocked() {
      if (reduceMql.matches) return true;
      var conn = navigator.connection;
      return !!(conn && conn.saveData === true);
    }

    /* Fallback, falls eine Video-Slide KEIN poster-Attribut hat: blockiert
       bliebe sie sonst leer (nur Hero-Hintergrund). Dann nur Metadaten laden,
       damit der erste Frame steht - kein Abspielen, kein Voll-Download.
       Mit Poster passiert hier nichts. */
    function showFirstFrame(v) {
      if (v.getAttribute('poster') || v.dataset.heroVideo) return;
      v.dataset.heroVideo = 'meta';
      try { v.preload = 'metadata'; v.load(); } catch (e) {}
    }

    function playVideo(slide) {
      var v = activeVideo(slide);
      if (!v) return;
      if (videoBlocked()) { showFirstFrame(v); return; }
      /* load() nur beim ersten Mal (oder nach Fehler): ein erneutes load()
         setzt das Video zurueck und fordert es neu an. Danach nur fortsetzen.
         Nach dem Metadaten-Fallback reicht preload='auto', play() laedt weiter. */
      var state = v.dataset.heroVideo;
      if (state !== '1' || v.error) {
        v.dataset.heroVideo = '1';
        try {
          v.preload = 'auto';
          if (state !== 'meta' || v.error) v.load();
        } catch (e) {}
      }
      var p = v.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    /* Automatischer Start fuer die aktive Slide - nur wenn das Gate offen ist */
    function tryPlayActive() {
      if (mediaReady && heroVisible) playVideo(slides[current]);
    }

    function pauseVideos(slide) {
      if (!slide) return;
      var vids = slide.querySelectorAll('video');
      for (var i = 0; i < vids.length; i++) { try { vids[i].pause(); } catch (e) {} }
    }

    /* fromUser = aktiver Wechsel (Pfeil/Punkt/Swipe/Editor): Video startet
       sofort. Ohne fromUser (Autoplay-Timer) greift das Video-Gate. */
    function setActive(i, fromUser) {
      i = ((i % count) + count) % count;
      var prev = current;
      current = i;

      for (var k = 0; k < slides.length; k++) {
        var on = (k === i);
        slides[k].classList.toggle('is-active', on);
        slides[k].setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      for (var d = 0; d < dots.length; d++) {
        var dotOn = (d === i);
        dots[d].classList.toggle('is-active', dotOn);
        if (dotOn) dots[d].setAttribute('aria-current', 'true');
        else dots[d].removeAttribute('aria-current');
      }
      /* Unter-Bild-Leiste synchron zur aktiven Slide umblenden */
      for (var bb = 0; bb < belowBars.length; bb++) {
        belowBars[bb].classList.toggle('is-active', parseInt(belowBars[bb].dataset.index, 10) === i);
      }
      /* Offene Newsletter-Formulare anderer Slides zurueckklappen (gibt
         gleichzeitig die Autoplay-Sperre frei) */
      for (var nr = 0; nr < nlRegistry.length; nr++) {
        var entry = nlRegistry[nr];
        if (entry.open && entry.ownerIdx !== i) {
          entry.open = false;
          entry.form.hidden = true;
          entry.toggle.hidden = false;
          if (entry.error) entry.error.hidden = true;
        }
      }

      loadSlideMedia(slides[i]);
      loadSlideMedia(slides[(i + 1) % count]);

      if (prev !== i) pauseVideos(slides[prev]);
      if (fromUser) playVideo(slides[i]);
      else tryPlayActive();
      syncHeaderTone(i);
    }

    /* Aktiven Slide-Ton an den Header melden: heller Slide-Text = dunkles
       Motiv -> transparenter Header soll weiss bleiben (section-header.js). */
    function syncHeaderTone(i) {
      hero.setAttribute('data-active-light-text', slides[i].getAttribute('data-light-text') || '1');
      document.dispatchEvent(new CustomEvent('hero:slidechange'));
    }

    function next(fromUser) { setActive(current + 1, fromUser); }
    function prev(fromUser) { setActive(current - 1, fromUser); }

    function startAutoplay() {
      stopAutoplay();
      if (destroyed) return;
      if (wantsAutoplay()) timer = window.setInterval(function () { next(false); }, interval);
    }
    function stopAutoplay() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }
    function restartAutoplay() {
      if (wantsAutoplay()) { stopAutoplay(); startAutoplay(); }
    }

    loadSlideMedia(slides[0]);
    syncHeaderTone(0);

    /* Sichtbarkeit: wer vor dem Start schon weggescrollt hat, laedt nichts,
       bis der Hero wieder im Bild ist. Ohne IO gilt der Hero als sichtbar. */
    var heroIo = null;
    if ('IntersectionObserver' in window) {
      heroIo = new IntersectionObserver(function (entries) {
        var en = entries[entries.length - 1];
        heroVisible = en.isIntersecting || en.intersectionRatio > 0;
        tryPlayActive();
      });
      heroIo.observe(hero);
    }

    /* Nachbar-Slide erst nach 'load' (nicht vor dem LCP), Video danach mit
       Reserve: mind. 1,5 s, dann im naechsten Leerlauf (max. 1 s spaeter). */
    function openVideoGate() {
      if (destroyed) return;
      mediaReady = true;
      tryPlayActive();
    }
    function afterLoad() {
      if (destroyed) return;
      if (count > 1) loadSlideMedia(slides[1]);
      window.setTimeout(function () {
        if ('requestIdleCallback' in window) window.requestIdleCallback(openVideoGate, { timeout: 1000 });
        else openVideoGate();
      }, 1500);
    }
    if (document.readyState === 'complete') afterLoad();
    else on(window, 'load', afterLoad);

    /* bfcache: beim Einfrieren pausiert der Browser das Video, der IO meldet
       nach der Wiederherstellung nichts Neues. Aktive Slide hier fortsetzen
       (data-hero-video verhindert ein erneutes load(), es kommt nur play()). */
    on(window, 'pageshow', function (e) {
      if (e.persisted) tryPlayActive();
    });

    if (nextBtn) on(nextBtn, 'click', function () { next(true); restartAutoplay(); });
    if (prevBtn) on(prevBtn, 'click', function () { prev(true); restartAutoplay(); });
    for (var dd = 0; dd < dots.length; dd++) {
      (function (dot) {
        on(dot, 'click', function () {
          setActive(parseInt(dot.dataset.heroDot, 10) || 0, true);
          restartAutoplay();
        });
      })(dots[dd]);
    }

    on(hero, 'mouseenter', stopAutoplay);
    on(hero, 'mouseleave', startAutoplay);
    on(hero, 'focusin', stopAutoplay);
    on(hero, 'focusout', startAutoplay);
    on(document, 'visibilitychange', function () {
      if (document.hidden) stopAutoplay(); else startAutoplay();
    });

    function onViewportChange() { pauseVideos(slides[current]); tryPlayActive(); }
    onMql(mqlDesktop, onViewportChange);

    /* Reduced motion zur Laufzeit umgestellt: an = Video anhalten (Bild bleibt
       stehen), aus = aktive Slide darf wieder (Gate beachten). */
    function onMotionChange() {
      if (reduceMql.matches) pauseVideos(slides[current]);
      else tryPlayActive();
    }
    onMql(reduceMql, onMotionChange);

    if (count > 1 && viewport) {
      var tx = 0, ty = 0, touching = false;
      on(viewport, 'touchstart', function (e) {
        var t = e.changedTouches[0]; tx = t.clientX; ty = t.clientY; touching = true;
      }, { passive: true });
      on(viewport, 'touchend', function (e) {
        if (!touching) return; touching = false;
        var t = e.changedTouches[0];
        var dx = t.clientX - tx, dy = t.clientY - ty;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) next(true); else prev(true);
          restartAutoplay();
        }
      }, { passive: true });
    }

    /* Warenkorb-CTA: [data-hero-atc] legt EINE Variante, [data-hero-atc-multi]
       (Kommaliste) legt MEHRERE Varianten als einzelne Positionen in den
       Cart-Drawer (Kaufe 3, bezahle 2 - Rabatt via automatischem Shopify-Discount).
       window.Cart oeffnet den Drawer selbst. Ohne window.Cart faellt der Klick
       auf den normalen Link zur Produktseite zurueck (kein preventDefault). */
    on(hero, 'click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('[data-hero-atc], [data-hero-atc-multi]') : null;
      if (!btn || !hero.contains(btn)) return;
      if (!window.Cart) return;
      var multi = btn.getAttribute('data-hero-atc-multi');
      var run = null;
      if (multi && typeof window.Cart.addMulti === 'function') {
        run = function () { return window.Cart.addMulti(multi.split(',')); };
      } else if (!multi && typeof window.Cart.add === 'function') {
        run = function () { return window.Cart.add(btn.getAttribute('data-hero-atc'), 1); };
      }
      if (!run) return;
      e.preventDefault();
      if (btn.dataset.heroAtcBusy === '1') return;
      btn.dataset.heroAtcBusy = '1';
      stopAutoplay();
      run()
        .catch(function () {})
        .then(function () { delete btn.dataset.heroAtcBusy; startAutoplay(); });
    });

    /* Newsletter-CTA: Button klappt das E-Mail-Feld auf, Anmeldung laeuft wie im
       Footer ueber window.pawSubscribe (Turnstile + Klaviyo, Double-Opt-in).
       Autoplay pausiert, solange das Formular offen ist (sonst slidet es weg). */
    var nlWraps = hero.querySelectorAll('[data-hero-nl]');
    for (var nw = 0; nw < nlWraps.length; nw++) {
      (function (wrap) {
        var toggle = wrap.querySelector('[data-hero-nl-toggle]');
        var form   = wrap.querySelector('[data-hero-nl-form]');
        if (!toggle || !form) return;
        var input     = form.querySelector('input[type="email"]');
        var field     = form.querySelector('[data-field]');
        var success   = form.querySelector('[data-success]');
        var error     = form.querySelector('[data-error]');
        var submitBtn = form.querySelector('button[type="submit"]');

        var owner = wrap.closest('[data-hero-slide], [data-hero-below]');
        var entry = {
          open: false,
          form: form,
          toggle: toggle,
          error: error,
          ownerIdx: owner ? parseInt(owner.dataset.index, 10) : -1
        };
        nlRegistry.push(entry);

        on(toggle, 'click', function () {
          toggle.hidden = true;
          form.hidden = false;
          entry.open = true;
          stopAutoplay();
          if (window.pawPrewarm) { try { window.pawPrewarm(form); } catch (e) {} }
          if (input) { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }
        });

        on(form, 'submit', function (e) {
          e.preventDefault();
          if (!input) return;
          if (!input.checkValidity()) {
            if (typeof input.reportValidity === 'function') input.reportValidity();
            else input.focus();
            return;
          }
          if (error) error.hidden = true;
          if (!window.pawSubscribe || !window.PAW_TURNSTILE_KEY) {
            if (error) {
              error.textContent = form.getAttribute('data-locale-unavailable') || error.textContent;
              error.hidden = false;
            }
            return;
          }
          if (submitBtn) submitBtn.disabled = true;
          window.pawSubscribe(form, (input.value || '').trim(), 'Paw Hero Newsletter')
            .then(function () {
              if (field) field.hidden = true;
              if (success) success.hidden = false;
              entry.open = false;
              startAutoplay();
            })
            .catch(function () {
              if (error) error.hidden = false;
            })
            .then(function () {
              if (submitBtn) submitBtn.disabled = false;
            });
        });
      })(nlWraps[nw]);
    }

    /* Inhaltshoehe je Slide als --ch bereitstellen: CSS klemmt damit die
       vertikale Position exakt an die Buehnen-Raender (siehe hero.liquid). */
    var contentRo = null;
    if ('ResizeObserver' in window) {
      var contentEls = hero.querySelectorAll('.hero__content');
      if (contentEls.length) {
        contentRo = new ResizeObserver(function (entries) {
          for (var ci = 0; ci < entries.length; ci++) {
            var cel = entries[ci].target;
            cel.style.setProperty('--ch', cel.offsetHeight + 'px');
          }
        });
        for (var ce = 0; ce < contentEls.length; ce++) contentRo.observe(contentEls[ce]);
      }
    }

    /* Theme-Editor: gewaehlte Slide zeigen und anhalten. Kommt auch nach jedem
       Re-Render (event.detail.load = true) - die neue Instanz zeigt dann wieder
       die gerade bearbeitete Slide statt Slide 1. */
    on(document, 'shopify:block:select', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('[data-hero-slide]') : null;
      if (slide && hero.contains(slide)) {
        var idx = slides.indexOf(slide);
        if (idx >= 0) { stopAutoplay(); setActive(idx, true); }
      }
    });
    on(document, 'shopify:block:deselect', function () { startAutoplay(); });

    hero.__pawHeroDestroy = function () {
      destroyed = true;
      stopAutoplay();
      if (heroIo) heroIo.disconnect();
      if (contentRo) contentRo.disconnect();
      for (var ps = 0; ps < slides.length; ps++) pauseVideos(slides[ps]);
      for (var cu = 0; cu < cleanups.length; cu++) cleanups[cu]();
      cleanups = [];
      hero.__pawHeroDestroy = null;
    };

    startAutoplay();
  }

  /* Start fuer alle Heroes im Dokument bzw. in einer (neu gerenderten) Section. */
  function heroesIn(root) {
    if (!root) return [];
    if (root.matches && root.matches('[data-hero]')) return [root];
    return root.querySelectorAll ? Array.prototype.slice.call(root.querySelectorAll('[data-hero]')) : [];
  }

  var initial = heroesIn(document);
  for (var hi = 0; hi < initial.length; hi++) initHero(initial[hi]);

  /* Theme-Editor: Block-/Section-Einstellungen rendern die Section neu, das
     Skript laeuft dabei nicht erneut. Alte Instanz sauber abbauen (Timer,
     Observer, document-Listener), neue an das frische Markup binden. */
  document.addEventListener('shopify:section:unload', function (e) {
    var list = heroesIn(e.target);
    for (var i = 0; i < list.length; i++) {
      if (typeof list[i].__pawHeroDestroy === 'function') list[i].__pawHeroDestroy();
    }
  });
  document.addEventListener('shopify:section:load', function (e) {
    var list = heroesIn(e.target);
    for (var i = 0; i < list.length; i++) initHero(list[i]);
  });
})();
